import { useRouter } from "next/router";

import { Tabs, TabsItemType } from "@zapier/design-system";

import { routes } from "@zapier/reporting/src/constants";

const tabItems: TabsItemType[] = [
  { href: routes.log, text: "Zap runs" },
  { href: routes.usage, text: "Task usage" },
];

export function HistoryTabNavigation() {
  const router = useRouter();

  return (
    <Tabs items={tabItems} selectedItemHref={router.pathname} size="medium" />
  );
}
